/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  LIST_BRANCHES_BEGIN,
  LIST_BRANCHES_SUCCESS,
  LIST_BRANCHES_ERR,

  CREATE_BRANCH_BEGIN,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_ERR,

  UPDATE_BRANCH_BEGIN,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_ERR,

  DELETE_BRANCH_BEGIN,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_ERR,

  BLOCK_BRANCH_BEGIN,
  BLOCK_BRANCH_SUCCESS,
  BLOCK_BRANCH_ERR,

  UNBLOCK_BRANCH_BEGIN,
  UNBLOCK_BRANCH_SUCCESS,
  UNBLOCK_BRANCH_ERR,

  GET_BRANCH_DETAILS_BEGIN,
  GET_BRANCH_DETAILS_SUCCESS,
  GET_BRANCH_DETAILS_ERR,
} = actions;

const initState = {
  loadingCreateBranch: false,
  errorCreateBranch: "",
  loadingUpdateBranch: false,
  errorUpdateBranch: "",
  branches: [],
  totalBranches: 0,
  totalBranchesPages: 0,
  loadingDeleteBranch: false,
  errorDeleteBranch: "",
  loadingBlockBranch: false,
  errorBlockBranch: null,
  loadingUnblockBranch: false,
  errorUnblockBranch: null,
  loadingGetBranchDetails: false,
  errorGetBranchDetails: null,
  branchDetails: {},
};

const branchesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_BRANCH_BEGIN:
      return {
        ...state,
        loadingCreateBranch: true,
        errorCreateBranch: "",
      };
    case CREATE_BRANCH_SUCCESS:
      return {
        ...state,
        branches: [...state.branches, data],
        loadingCreateBranch: false,
        errorCreateBranch: "",
      };
    case CREATE_BRANCH_ERR:
      return {
        ...state,
        errorCreateBranch: err,
        loadingCreateBranch: false,
      };

    case LIST_BRANCHES_BEGIN:
      return {
        ...state,
        loadingListBranches: true,
        errorListBranches: false,
        totalBranches: 0,
        totalBranchesPages: 0,
      };
    case LIST_BRANCHES_SUCCESS:
      return {
        ...state,
        branches: [...data.results],
        loadingListBranches: false,
        errorListBranches: null,
        totalBranches: data.total_count,
        totalBranchesPages: data.total_pages,
      };
    case LIST_BRANCHES_ERR:
      return {
        ...state,
        errorListBranches: err,
        loadingListBranches: false,
        totalBranches: 0,
        totalBranchesPages: 0,
      };

    case UPDATE_BRANCH_BEGIN:
      return {
        ...state,
        loadingUpdateBranch: true,
        errorUpdateBranch: false,
      };
    case UPDATE_BRANCH_SUCCESS:
      const updatedBranches = state.branches.map((branch) =>
        branch.id === data.id ? { ...branch, ...data } : branch
      );
      return {
        ...state,
        branches: updatedBranches,
        loadingUpdateBranch: false,
        errorUpdateBranch: null,
      };
    case UPDATE_BRANCH_ERR:
      return {
        ...state,
        errorUpdateBranch: err,
        loadingUpdateBranch: false,
      };

    case DELETE_BRANCH_BEGIN:
      return {
        ...state,
        loadingDeleteBranch: true,
        errorDeleteBranch: null,
      };
    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
        branches: state.branches.filter((branch) => branch.id !== data.id),
        loadingDeleteBranch: false,
        errorDeleteBranch: null,
      };
    case DELETE_BRANCH_ERR:
      return {
        ...state,
        errorDeleteBranch: err,
        loadingDeleteBranch: false,
      };

    case BLOCK_BRANCH_BEGIN:
      return {
        ...state,
        loadingBlockBranch: true,
        errorBlockBranch: null,
      };
    case BLOCK_BRANCH_SUCCESS:
      return {
        ...state,
        loadingBlockBranch: false,
        errorBlockBranch: null,
      };
    case BLOCK_BRANCH_ERR:
      return {
        ...state,
        errorBlockBranch: err,
        loadingBlockBranch: false,
      };

    case UNBLOCK_BRANCH_BEGIN:
      return {
        ...state,
        loadingUnblockBranch: true,
        errorUnblockBranch: null,
      };
    case UNBLOCK_BRANCH_SUCCESS:
      return {
        ...state,
        loadingUnblockBranch: false,
        errorUnblockBranch: null,
      };
    case UNBLOCK_BRANCH_ERR:
      return {
        ...state,
        loadingUnblockBranch: false,
        errorUnblockBranch: err,
      };

    case GET_BRANCH_DETAILS_BEGIN:
      return {
        ...state,
        branchDetails: {},
        loadingGetBranchDetails: true,
        errorGetBranchDetails: null,
      };
    case GET_BRANCH_DETAILS_SUCCESS:
      return {
        ...state,
        branchDetails: data,
        loadingGetBranchDetails: false,
        errorGetBranchDetails: null,
      };
    case GET_BRANCH_DETAILS_ERR:
      return {
        ...state,
        branchDetails: {},
        loadingGetBranchDetails: false,
        errorGetBranchDetails: err,
      };

    default:
      return state;
  }
};

export { branchesReducer };
